<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'
import { BrowserMultiFormatOneDReader, BrowserCodeReader } from '@zxing/browser'
import Loader from '../Loader.vue'

const emit = defineEmits(['barcode-scanned'])

const started = ref(false)
let paused: boolean | null = false
let controls: any

onMounted(async () => {
  const codeReader = new BrowserMultiFormatOneDReader()
  const videoInputDevices = await BrowserCodeReader.listVideoInputDevices()
  const selectedDeviceId = videoInputDevices[videoInputDevices.length - 1].deviceId

  try {
    controls = await codeReader.decodeFromVideoDevice(
      selectedDeviceId,
      'camera-scanner-video',
      (result) => {
        if (result && !paused) {
          console.log('Barcode scanned:', result)

          const value = result.getText().trim()
          emit('barcode-scanned', value)

          paused = true
          setTimeout(() => (paused = false), 3000)
        }
      },
    )
    started.value = true
  } catch (e) {
    console.error(e)
  }
})
onUnmounted(() => {
  controls.stop()
})

/**
 * Fix setPhotoOptions failed error
 * https://github.com/zxing-js/browser/issues/115
 */
 BrowserCodeReader.mediaStreamSetTorch = async () => {}
</script>

<template>
  <div class="camera-scanner-wrapper">
    <div class="camera-scanner" v-show="started">
      <div class="line"></div>
      <img src="./assets/target-top-left.svg" class="target top left" />
      <img src="./assets/target-top-right.svg" class="target top right" />
      <img src="./assets/target-bottom-left.svg" class="target bottom left" />
      <img src="./assets/target-bottom-right.svg" class="target bottom right" />
      <video
        id="camera-scanner-video"
        autoplay="true"
        preload="auto"
        src=""
        muted="true"
        playsinline="true"
      ></video>
    </div>
    <Loader v-show="!started" />
  </div>
</template>

<style scoped lang="scss">
.camera-scanner-wrapper {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .camera-scanner {
    width: 100%;
    height: 100%;

    .line {
      width: calc(100% - 40px);
      height: 4px;
      margin-left: 20px;
      position: absolute;
      top: calc(50% - 2px);
      z-index: 2;
      background-color: #344c60;
      border-radius: 2px;
    }

    .target {
      padding: 2vw;
      position: absolute;
      z-index: 2;

      &.top {
        top: 0;
      }
      &.bottom {
        bottom: 0;
      }
      &.left {
        left: 0;
      }
      &.right {
        right: 0;
      }
    }

    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
